module.exports = __webpack_public_path__ + "static/media/wt-institution1.9c447c3e.png";